import { subDays } from 'date-fns';

import { Response } from '@custom-types/Response';
import { HAPPENING, Session, Track, UPCOMING } from '@custom-types/Session';
import apiFn from '@services/api-service';

const api = (eventId: string) => apiFn(`/api/uapi/events/${eventId}/sessions`);

const transform = (session: Session) => {
  const startDate = new Date(session.startDatetime);
  const now = new Date();

  if (startDate > now) {
    Object.assign(session, { group: UPCOMING });
  } else {
    Object.assign(session, { group: HAPPENING });
  }

  return session;
};

export const list = (
  eventId: string,
  page: number,
  selectedTracks: string[],
  searchValue?: string
) => {
  const params = {
    sort: 'start_datetime',
    endDatetimeAfter: subDays(Date.now(), 1).toISOString(),
    page,
    limit: 10,
    include: 'location,tracks',
  };

  if (selectedTracks?.length > 0) {
    const trackIds = selectedTracks.reduce((p, c) => `${p}${c},`, '');
    Object.assign(params, { trackId: trackIds?.substring(0, trackIds.length - 1) });
  }

  if (searchValue) {
    Object.assign(params, { search: searchValue });
  }

  return api(eventId)
    .get('', { params })
    .then((response: Response<Session[]>) => {
      response.data.data.map(session => transform(session));
      return response.data;
    });
};

export const getTracks = (eventId: string) =>
  api(eventId)
    .get('tracks')
    .then((response: Response<Track[]>) => response?.data?.data);
